import { render, staticRenderFns } from "./NgEmail.vue?vue&type=template&id=4e0dae3a"
import script from "./NgEmail.vue?vue&type=script&lang=js"
export * from "./NgEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports